function buildCards(quantity) {
  const cards = [];
  for (let i = 0; i < quantity; i += 1) {
    cards.push({
      $unique_key: new Date().getTime() + i,
      cardImage: {
        src: 'https://www.nerdwallet.com/cdn/landing-pages/lpc/NW_Logo.png',
        objectFit: 'fill',
        objectPosition: 'top',
      },
      title: {
        text: 'Title goes here',
        textType: 'text',
        groupButton: {
          center: true,
          bold: true,
        },
        margin: {
          currency: {
            top: '0',
          },
        },
        textSize: 'large',
      },
      subtitle: {
        text: 'This is a subtitle',
        textType: 'text',
        groupButton: {
          center: true,
        },
        margin: {
          currency: {
            bottom: '0.5rem',
          },
        },
      },
      cardBackgroundColor: {
        backgroundColor: '',
        hexColor: '',
        border: {
          type: 'rounded',
          borderRounded: {
            currencyValue: 'border-radius-2',
          },
        },
        padding: {
          currency: {
            bottom: '1.75rem',
          },
        },
      },
      eyebrow: {
        text: '',
        textType: 'text',
      },
      bodyCopy: {
        text: 'Lorem ipsum dolor sit amet. Qui repellat nesciunt aut dolorem possimus et veritatis molestiae aut facere soluta id labore nihil et nemo distinctio.',
        textType: 'text',
        groupButton: {
          center: true,
        },
      },
    });
  }
  return cards;
}
export const defaultProps = {
  container: { backgroundColor: 'HEXCOLOR', hexColor: '#eeeeee' },
  title: {
    text: '< This is a Title />',
    groupButton: {
      center: true,
      bold: true,
    },
    textType: 'title',
    margin: {
      currency: {
        bottom: '0.5rem',
      },
    },
    padding: {
      currency: {
        top: '2.75rem',
      },
    },
  },
  subtitle: {
    text: 'This is a subtitle for the FlexCards component',
    textType: 'text',
    groupButton: {
      center: true,
    },
    margin: {
      currency: {
        top: '0',
        bottom: '0',
      },
    },
  },
  disableDefaultProps: false,
  cards: buildCards(3),
};
